module.exports = __webpack_public_path__ + "img/maestro.7608fdd0.svg";